import { cva } from 'class-variance-authority';
export var buttonVariants = cva('inline-flex items-center transition-colors duration-200 justify-between rounded-full text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', {
    defaultVariants: {
        size: 'default',
        variant: 'default',
    },
    variants: {
        size: {
            default: 'h-11 px-7 py-1 text-base',
            hasIcon: 'h-11 pl-7 pr-1 py-1',
            icon: 'h-10 w-10',
            lg: 'h-11 rounded-md px-8 text-lg',
            noPadding: 'px-0 py-0',
            sm: 'h-10 rounded-full px-4 text-xs font-semibold',
            ui: 'h-8 px-2 py-1 rounded-sm text-sm font-normal text-default',
        },
        variant: {
            black: 'text-white bg-neutral-900 hover:bg-neutral-800',
            default: 'bg-primary text-white hover:bg-primary/90',
            destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
            ghost: 'hover:text-primary',
            link: 'text-primary underline-offset-4 hover:underline font-bold',
            outline: 'border border-primary bg-white hover:bg-primary hover:text-primary-foreground text-primary font-bold',
            outlineGray: 'border hover:bg-primary hover:text-primary-foreground text-primary font-bold',
            secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
            secondaryOutline: 'border border-secondary hover:bg-secondary hover:text-white text-secondary font-bold',
        },
    },
});
